import React, { memo } from 'react'

export const NounArrow = memo(({ fillColor }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 100">
			<path
				d="M255.718 18.978L237.829 1.227c-1.648-1.636-4.395-1.636-6.044 0-1.648 1.636-1.648 4.362 0 5.998l10.562 10.542H4.274C1.893 17.767 0 19.645 0 22.007c0 2.363 1.893 4.242 4.274 4.242h238.073l-10.562 10.48c-1.648 1.637-1.648 4.363 0 5.999A4.32 4.32 0 00234.838 44a4.32 4.32 0 003.053-1.272l17.827-17.691a4.297 4.297 0 001.282-3.03c0-1.15-.427-2.241-1.282-3.029z"
				fill={fillColor}
				fillRule="nonzero"
			/>
		</svg>
	)
})
